export default "/images/vendor/flag-icon-css/flags/4x3/km.svg?636e9ed727bb8f644964906fc66d223f";